var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer", class: { common_footer: _vm.isShow } },
    [
      _c(
        "div",
        { staticClass: "wrap footerWrap" },
        [
          _vm._l(_vm.items, function(item, index) {
            return _c(
              "ul",
              { key: item.id, staticClass: "list-content" },
              [
                _c("li", { staticClass: "list-title" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.select(index)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.lang === "en" ? item.name_en : item.name)
                      )
                    ]
                  ),
                  _c(
                    "b",
                    {
                      staticClass: "show",
                      attrs: { "data-show": "close" },
                      on: { click: _vm.show }
                    },
                    [_vm._v("+")]
                  )
                ]),
                _vm._l(item.child, function(childItem) {
                  return _c(
                    "li",
                    { key: childItem.id, staticClass: "list-name" },
                    [
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                path: childItem.url,
                                query: { lang: _vm.lang }
                              })
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.lang === "en"
                                ? childItem.name_en
                                : childItem.name
                            )
                          )
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            )
          }),
          _c("ul", { staticClass: "footer-lang" }, [
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.toggleLang("en")
                  }
                }
              },
              [_vm._v("EN")]
            ),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.toggleLang("cn")
                  }
                }
              },
              [_vm._v("CN")]
            )
          ]),
          _c("div", { staticClass: "cle" }),
          _c("div", { staticClass: "footer-relative" }, [
            _c("ul", { staticClass: "social" }, [
              _c("li", [
                _c("button", [
                  _c("i", {
                    staticClass: "icon icon-wechat",
                    on: {
                      click: function($event) {
                        _vm.detailExpanding = !_vm.detailExpanding
                      }
                    }
                  })
                ])
              ]),
              _vm._m(0),
              _c("li", { staticClass: "totop" }, [
                _c("button", { on: { click: _vm.backTop } }, [
                  _c("i", { staticClass: "icon icon-totop" })
                ])
              ])
            ]),
            _c("p", [_vm._v("© 2018 Dongyi All rights resvered.")])
          ])
        ],
        2
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "fade",
            "enter-active-class": "fadeIn",
            "leave-active-class": "fadeOut"
          }
        },
        [
          _vm.detailExpanding
            ? _c(
                "div",
                {
                  staticClass: "footer-bar_menu",
                  style: { height: _vm.winHeight + "px" }
                },
                [
                  _vm.detailExpanding
                    ? _c(
                        "button",
                        {
                          staticClass: "icon-close",
                          on: {
                            click: function($event) {
                              ;(_vm.detailExpanding = !_vm.detailExpanding),
                                (_vm.detailExpanding = false),
                                (_vm.idx = null)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "svgMenu line1" }),
                          _c("span", { staticClass: "svgMenu line2" }),
                          _c("span", { staticClass: "svgMenu line3" })
                        ]
                      )
                    : _vm._e(),
                  _c("img", {
                    staticClass: "qrcode",
                    attrs: {
                      src:
                        "http://cdn.dongliyuanlin.com/image/qrcode_wechat.png",
                      alt: "qrcode"
                    }
                  })
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "http://weibo.com" } }, [
        _c("i", { staticClass: "icon icon-weibo" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3053fb41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3053fb41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CommonFooter.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3053fb41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CommonFooter.vue
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14